import { useTranslation } from "react-i18next";

import { formatImgUrl } from "../../../utils/cardFormating";
import { getEntityProfileRoute } from "../../../routers/routeUtils";

import { Entity } from "../../../types/types";

const DEFAULT_VALUES = {
  fullName: "",
  firstTwoChr: "",
  about: "",
  club: "",
  countryName: "",
  countryMedia: "",
  cityName: "",
  media: "",
  mediaFileName: "",
  role: "",
  profileViewers: 0,
  verificationStatus: "",
  isVerified: false,
  posts: 0,
  followersCount: 0,
  followingCount: 0,
  id: "",
  entityId: "",
  isFollowing: false,
  profileLink: "",
  mutualFollowersCount: 0,
  countryFlag: "",
  playerPositionShort: null,
  friendsCount: null,
  isManagedByEntity: false,
  entityLevel: null,
  mutualFriendsCount: null,
  foundedYear: null,
};

export const useEntityDataFormatter = (data: Entity | undefined) => {
  const { t } = useTranslation("common");

  if (!data) {
    return DEFAULT_VALUES;
  }

  const getTranslatedEntityLevel = (level: string): string | null => {
    const translated = t(`entity.entityLevel.${level}`);
    return translated === `entity.entityLevel.${level}` ? null : translated;
  };

  return {
    fullName: data.name,
    firstTwoChr: data.name.trim().slice(0, 2).toLocaleUpperCase(),
    about: data.about,
    club: "",
    countryName: data.country?.name || "",
    countryMedia: formatImgUrl(data.country?.url || "", true),
    cityName: "",
    media: formatImgUrl(data.mediaUrl),
    mediaFileName: data.mediaUrl,
    role: t(`entity.entityType.${data.type}`),
    profileViewers: data.profileViewers || 0,
    verificationStatus: data.status || "",
    isVerified: data.status === "approved",
    posts: data.posts || 0,
    followersCount: data.followersCount,
    followingCount: data.followingCount || 0,
    id: data.userId,
    entityId: data.id,
    isFollowing: data.isFollowing || false,
    profileLink: getEntityProfileRoute(data.id),
    mutualFollowersCount: 0,
    countryFlag: formatImgUrl(data.country?.url || ""),
    playerPositionShort: null,
    friendsCount: null,
    isManagedByEntity: data.isManagedByEntity,
    entityLevel: getTranslatedEntityLevel(data.level),
    mutualFriendsCount: null,
    foundedYear: data?.foundedYear ?? null,
  };
};
